import { onboardingMessagesActionTypes } from '@/components/onboardingMessages/Constants';

export function setOnboardingMessagesType(
	onboardingMessagesType: string | null,
	onboardingMessagesData?: any,
) {
	return {
		type: onboardingMessagesActionTypes.SET_ONBOARDING_MESSAGES_TYPE,
		payload: {
			onboardingMessagesType,
			onboardingMessagesData,
		},
	};
}
